import React, { useState, createContext, useMemo } from 'react'

const SearchContext = createContext()

const SearchContextProvider = ({ initialValue, children }) => {
  const { items: productItems = [] } = initialValue?.products || {}
  const [searchState, setSearchState] = useState(initialValue)
  const value = useMemo(
    () => ({
      searchState: {
        ...searchState,
        products: {
          ...searchState.products,
          items: productItems,
        },
      },
      setSearchContext: data => {
        setSearchState(prev => ({
          ...prev,
          ...data,
        }))
      },
    }),
    [searchState, productItems],
  )

  return (
    <SearchContext.Provider value={value}>{children}</SearchContext.Provider>
  )
}
export default SearchContextProvider
export { SearchContext }
